import {
  addDays,
  differenceInYears,
  endOfDay,
  format as dfFormat,
  isBefore,
  parseISO,
  startOfDay,
  subDays,
  toDate,
} from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

// Minimal token mapping used in this codebase
var TOKEN_MAP = {
  'MMM D': 'MMM d',
  'YYYY-MM-DD': 'yyyy-MM-dd',
  'h:mm a': 'h:mm a',
};

function mapToken(token) {
  if (!token) return token;
  // Common replacements from moment -> date-fns tokens
  var t = token;
  t = t.replace(/YYYY/g, 'yyyy');
  t = t.replace(/YY/g, 'yy');
  t = t.replace(/DDD/g, 'DDD');
  t = t.replace(/ddd/g, 'EEE');
  t = t.replace(/DD/g, 'dd');
  // replace single D (day of month) after replacing DD
  t = t.replace(/\bD\b/g, 'd');
  // apply explicit map entries last
  if (TOKEN_MAP[token]) return TOKEN_MAP[token];
  return t;
}

function parseISOorDate(input) {
  if (input === undefined || input === null || input === '') return null;
  if (input instanceof Date) return input;
  if (typeof input === 'string') return parseISO(input);
  return toDate(input);
}

const dateAdapter = {
  parseISO: function (s) {
    return parseISOorDate(s);
  },
  toDate: function (v) {
    return parseISOorDate(v);
  },
  format: function (date, token, opts) {
    var d = parseISOorDate(date);
    if (!d || isNaN(d.getTime())) return "";
    var mapped = mapToken(token || '');
    opts = opts || {};
    if (opts.timeZone) {
      var zoned = utcToZonedTime(d, opts.timeZone);
      return dfFormat(zoned, mapped, { locale: opts.locale });
    }
    return dfFormat(d, mapped, { locale: opts.locale });
  },
  startOfDay: function (date) { return startOfDay(parseISOorDate(date)); },
  endOfDay: function (date) { return endOfDay(parseISOorDate(date)); },
  addDays: function (date, days) { return addDays(parseISOorDate(date), days); },
  subDays: function (date, days) { return subDays(parseISOorDate(date), days); },
  differenceInYears: function (a, b) { return differenceInYears(parseISOorDate(a), parseISOorDate(b)); },
  isBefore: function (a, b) { return isBefore(parseISOorDate(a), parseISOorDate(b)); },
  tz: function (date, zone) {
    // Return a Date representing the same absolute time converted to the zone
    var d = parseISOorDate(date);
    return utcToZonedTime(d, zone);
  },
  now: function () { return new Date(); },
  toISOString: function (date) { return parseISOorDate(date).toISOString(); },
  zonedTimeToUtc: function (date, zone) { return zonedTimeToUtc(parseISOorDate(date), zone); }
};

export default dateAdapter;
